import React from 'react';
import { ConfirmDialog } from '@personal-dashboard/ui';

interface DeleteNoteDialogProps {
  open: boolean;
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const DeleteNoteDialog: React.FC<DeleteNoteDialogProps> = ({
  open,
  loading,
  onConfirm,
  onCancel,
}) => {
  return (
    <ConfirmDialog
      open={open}
      title="Delete Note"
      message="Are you sure you want to delete this note?"
      confirmLabel="Delete"
      severity="error"
      loading={loading}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};

export default DeleteNoteDialog;
